import Blockly from './blockly_compressed.js';
export const {
  Block,
  BlockFlyoutInflater,
  BlockNavigationPolicy,
  BlockSvg,
  Blocks,
  ButtonFlyoutInflater,
  COLLAPSED_FIELD_NAME,
  COLLAPSED_INPUT_NAME,
  COLLAPSE_CHARS,
  CodeGenerator,
  CollapsibleToolboxCategory,
  ComponentManager,
  Connection,
  ConnectionChecker,
  ConnectionDB,
  ConnectionNavigationPolicy,
  ConnectionType,
  ContextMenu,
  ContextMenuItems,
  ContextMenuRegistry,
  Css,
  DELETE_VARIABLE_ID,
  DeleteArea,
  DragTarget,
  DropDownDiv,
  Events,
  Extensions,
  Field,
  FieldCheckbox,
  FieldDropdown,
  FieldImage,
  FieldLabel,
  FieldLabelSerializable,
  FieldNavigationPolicy,
  FieldNumber,
  FieldTextInput,
  FieldVariable,
  Flyout,
  FlyoutButton,
  FlyoutButtonNavigationPolicy,
  FlyoutItem,
  FlyoutMetricsManager,
  FlyoutNavigationPolicy,
  FlyoutNavigator,
  FlyoutSeparator,
  FlyoutSeparatorNavigationPolicy,
  FocusManager,
  FocusableTreeTraverser,
  Generator,
  Gesture,
  Grid,
  HorizontalFlyout,
  INPUT_VALUE,
  Input,
  InsertionMarkerPreviewer,
  KeyboardNavigationController,
  LabelFlyoutInflater,
  LineCursor,
  Marker,
  MarkerManager,
  Menu,
  MenuItem,
  MetricsManager,
  Msg,
  NEXT_STATEMENT,
  Names,
  Navigator,
  OPPOSITE_TYPE,
  OUTPUT_VALUE,
  Options,
  PREVIOUS_STATEMENT,
  PROCEDURE_CATEGORY_NAME,
  Procedures,
  RENAME_VARIABLE_ID,
  RenderedConnection,
  Scrollbar,
  ScrollbarPair,
  SeparatorFlyoutInflater,
  ShortcutItems,
  ShortcutRegistry,
  TOOLBOX_AT_BOTTOM,
  TOOLBOX_AT_LEFT,
  TOOLBOX_AT_RIGHT,
  TOOLBOX_AT_TOP,
  Theme,
  ThemeManager,
  Themes,
  Toast,
  Toolbox,
  ToolboxCategory,
  ToolboxItem,
  ToolboxSeparator,
  Tooltip,
  Touch,
  Trashcan,
  UnattachedFieldError,
  VARIABLE_CATEGORY_NAME,
  VARIABLE_DYNAMIC_CATEGORY_NAME,
  VERSION,
  VariableMap,
  VariableModel,
  Variables,
  VariablesDynamic,
  VerticalFlyout,
  WidgetDiv,
  Workspace,
  WorkspaceAudio,
  WorkspaceDragger,
  WorkspaceNavigationPolicy,
  WorkspaceSvg,
  Xml,
  ZoomControls,
  blockAnimations,
  blockRendering,
  browserEvents,
  bubbles,
  bumpObjects,
  clipboard,
  comments,
  common,
  config,
  constants,
  defineBlocksWithJsonArray,
  dialog,
  dragging,
  fieldRegistry,
  geras,
  getFocusManager,
  getMainWorkspace,
  getSelected,
  hasBubble,
  hideChaff,
  icons,
  inject,
  inputs,
  isCopyable,
  isDeletable,
  isDraggable,
  isIcon,
  isObservable,
  isPaster,
  isRenderedElement,
  isSelectable,
  isSerializable,
  isVariableBackedParameterModel,
  keyboardNavigationController,
  layers,
  navigateBlock,
  navigateStacks,
  procedures,
  registry,
  renderManagement,
  serialization,
  setLocale,
  setParentContainer,
  svgResize,
  thrasos,
  uiPosition,
  utils,
  zelos,
} = Blockly;
